import React from 'react';
import styles from './styles.module.css';

export default function AvatarBadges({ text }: { text?: string }) {
  return (
    <div className={styles.trust}>
      <div className={styles.avatars}>
        <span className={styles.av1} />
        <span className={styles.av2} />
        <span className={styles.av3} />
      </div>
      {text && <span className={styles.trustText}>{text}</span>}
    </div>
  );
}
